/** @type {Styles} */
export const styles = {
  menuItem: {
    px: 2,
    py: 1.5,
    gap: 1,
  },
  menuItemIcon: {
    minWidth: 'unset',
    fontSize: '1.5rem',
    color: 'gray.64',
  },
  menuItemText: {
    '& .MuiListItemText-primary': {
      fontSize: '1rem',
      fontWeight: 400,
      color: 'gray.80',
    },
  },
  stopTimerIcon: {
    minWidth: 'unset',
    fontSize: '1.5rem',
    color: 'error.main',
  },
  stopTimerText: {
    '& .MuiListItemText-primary': {
      fontSize: '1rem',
      fontWeight: 400,
      color: 'error.main',
    },
  },
  menuDivider: {
    my: 1,
  },
}
